import { Checkbox as HeadlessCheckbox, Field, Label } from '@headlessui/react'
import React from 'react'

type CheckboxProps = {
  children?: React.ReactNode
} & Omit<React.ComponentPropsWithoutRef<typeof HeadlessCheckbox>, 'children'>

function Checkbox({ children, ...props }: CheckboxProps) {
  return (
    <Field className="flex items-center gap-2">
      <HeadlessCheckbox
        className="group relative flex size-4 cursor-pointer items-center gap-5 rounded-[4px] border bg-slider/75 before:absolute before:inset-[-4px] before:content-[''] data-[disabled]:cursor-not-allowed data-[checked]:bg-neutral-midfi-grey data-[disabled]:opacity-50 sm:before:content-none"
        {...props}
      >
        <svg
          className="stroke-neutral-white opacity-0 group-data-[checked]:opacity-100"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="17"
          viewBox="0 0 16 17"
          fill="none"
        >
          <path
            d="M2.66675 9.24365L5.64653 12.2234C5.84179 12.4187 6.15837 12.4187 6.35363 12.2234L13.3334 5.24365"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </HeadlessCheckbox>
      <Label onClick={(e) => e.preventDefault()}>{children}</Label>
    </Field>
  )
}

export default Checkbox
